var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro-page"},[_c('div',{staticStyle:{"width":"80%","margin":"auto"}},[_c('span',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.Title))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"intro"},[_vm._v("MS Student @ Carnegie Mellon University | Actively seeking SDE internship opportunities 2023 summer")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d46e2a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro.vue
// module id = null
// module chunks = 